import PropTypes from 'prop-types';
import Mobile from './Mobile';
import Desktop from './Desktop';
import Cookies from 'js-cookie';
import useNotification from '../../globalStore/notification';
import updateNotificationStatus from '../../helpers/http/notificationStatus';
import { setDataLayer } from 'Helpers/utils'

const Notification = ({ ...props }) => {
	const data = useNotification((state) => state.data);

	const handleOnClose = (id) => {
		useNotification?.getState()?.removeNotification(id);
	};
	const handleSeenNotif = (params) => {

		const auth = Cookies.get('token');
		const dataLayerObj = {
			event: 'click_push_notification',
			username: Cookies.get('usrname'),
			category_notif: params.category_notif,
			subcategory_notif: params.subcategory_notif,
			type_notif: params.type_notif
		}
		setDataLayer(dataLayerObj, 'GTM')

		if (auth) {
			updateNotificationStatus({
				authorization: auth,
				body: {
					id: params.notifId,
					is_read_from: 'push_notification',
				},
			})
				.then((res) => {
					if (res.data.meta.code === 200) {
						window.location.href = params.url;
					}
					return null;
				})
				.catch(() => { });
		}
	};

	if (data.length < 1) return null;

	if (props.isMobile) {
		return (
			<Mobile
				data={data}
				onClose={handleOnClose}
				handleSeenNotif={handleSeenNotif}
			/>
		);
	}
	return (
		<Desktop
			data={data}
			onClose={handleOnClose}
			handleSeenNotif={handleSeenNotif}
		/>
	);
};

Notification.propTypes = {
	isMobile: PropTypes.bool,
};

Notification.defaultProps = {
	isMobile: false,
};

export default Notification;
